export default "__VITE_ASSET__071392da__"